import { Box, Text, Flex } from "@chakra-ui/react";

interface AssistantMessageProps {
  text: string;
}

const AssistantMessage: React.FC<AssistantMessageProps> = ({ text }) => {
  return (
    <Flex justify="flex-start" w="100%">
      <Box
       // bg="white"
        px={4}
        py={3}
        borderRadius="16px"
        maxW="720px"
       // boxShadow="md"
      >
        <Text textAlign={"left"} color="#667085">
          {text}
        </Text>
      </Box>
    </Flex>
  );
};

export default AssistantMessage;
